<style src="./TreeList.scss" lang="scss"></style>

<script>
	export default {
		name: 'HpTreeList',
		props: ['element'],
		methods: {
			toggleChildren(e) {
				e.preventDefault();
				this.$el.classList.toggle('open');
			}
		}
	};
</script>

<template>
	<li data-component="TreeList">
		<a :href="element.link">
			<p>{{ element.text }}</p>
			<span data-arrow-down @click="toggleChildren" v-if="element.submenu && element.submenu.length"><i></i></span>
		</a>

		<ul v-if="element.submenu && element.submenu.length">
			<hp-tree-list v-for="(subElement, index2) in element.submenu" :element="subElement" :key="index2"> </hp-tree-list>
		</ul>
	</li>
</template>
